/**
 * Abre as boas-vindas pelo menu Conta › O que há de novo. O código da apresentação só carrega
 * quando ela abre.
 */
import { Suspense, lazy } from 'react';
import { useBoasVindasStore } from './boasVindasStore';

const BoasVindas = lazy(() => import('./BoasVindas'));

export function BoasVindasHost(): JSX.Element | null {
  const peloMenu = useBoasVindasStore((s) => s.peloMenu);
  const fechar = useBoasVindasStore((s) => s.fechar);
  if (!peloMenu) return null;
  return (
    <Suspense fallback={null}>
      <BoasVindas origem="menu" onFechar={fechar} />
    </Suspense>
  );
}
